export default __webpack_public_path__ + "static/media/flexline_hd_logo_no.31625b54.png";